export default "__VITE_ASSET__DMHOQikX__"